﻿import {expressQuerySelector, hide, expressQuerySelectorAll, remove, show} from "../common/html";

export interface ICreateShowMoreButtonOptions {
		onClick: () => void;
	}

	export function createShowMoreButton(containerEl: HTMLElement, options: ICreateShowMoreButtonOptions) {

		const onClick = () => options.onClick();

		const enable = () => {
			const buttonEl = expressQuerySelector(containerEl, ".a-button");

			containerEl.removeEventListener("click", onClick);
			containerEl.addEventListener("click", onClick);

			if (buttonEl) buttonEl.classList.add("a-button--active");
		};

		const disable = () => {
			containerEl.removeEventListener("click", onClick);
		};

		const show = () => {
			containerEl.style.display = '';
		};

		const hide = () => {
			containerEl.style.display = 'none';
		};

		const dispose = () => {
			disable();
		};

		enable();

		return {
			show,
			hide,
			enable,
			disable,
			dispose,
		};
	}

	export interface ICreatePaginationControlOptions {
		onClick: (page: number) => void;
		readonly numberOfPages: number;
	}

	export function createPaginationControl(containerEl: HTMLElement, options: ICreatePaginationControlOptions) {
		const buttonTemplateEl = containerEl.querySelector(".m-review-blocks-controls__button")!;

		const leftControlEL = buttonTemplateEl.cloneNode(true) as HTMLElement;
		expressQuerySelector(leftControlEL, 'button', true)
			.className += " icon-arrow-left m-review-blocks-controls__pagination-button";
		const leftButton = leftControlEL.querySelector("button");
		if (leftButton) leftButton.title = "previous";
		hide(leftControlEL);

		const rightControlEL = buttonTemplateEl.cloneNode(true) as HTMLElement;
		expressQuerySelector(rightControlEL, 'button', true)
			.className += " icon-arrow-right m-review-blocks-controls__pagination-button";
		const rightButton = rightControlEL.querySelector("button");
		if (rightButton) rightButton.title = "next";
		hide(rightControlEL);

		const reviewBlocksControlEl = document.getElementsByClassName('m-review-blocks-controls');

		reviewBlocksControlEl[1].insertAdjacentElement('afterbegin', leftControlEL);
		reviewBlocksControlEl[1].insertAdjacentElement('beforeend', rightControlEL);

		remove(buttonTemplateEl);

		let numberedButtonEls: HTMLElement[] = [];

		const amountOfPagesToShow = parseInt(containerEl.getAttribute('data-amount-of-pages')!, 10) || 5;
		let { numberOfPages } = options;
		let indexOffset = 0;

		let selectedPage: number;

		const onNumberedButtonClicked = (e: Event) => {
			const buttonEl = e.currentTarget as HTMLElement;
			options.onClick(
				parseInt(
					buttonEl.textContent!,
					10)
			);
		};

		const showArrowControl = (showIt: boolean, el: HTMLElement) => {
			if (showIt) {
				show(el);
				el.removeEventListener("click", onClickArrowControl);
				el.addEventListener("click", onClickArrowControl);
			} else {
				hide(el);
				el.removeEventListener("click", onClickArrowControl);
			}
		};

		const updatePaginations = (pages?: number, pageNumber?: number) => {
			if (pageNumber) {
				if (pageNumber === 1) indexOffset = 0;
				selectedPage = pageNumber;
			}

			if (pages) numberOfPages = pages;

			numberedButtonEls = [];

			expressQuerySelectorAll(containerEl, ".m-review-blocks-controls__button.numbered-control")
				.forEach(remove);

			const indexCondition = Math.min(
				(numberOfPages + 1),
				(amountOfPagesToShow + 1 + indexOffset)
			);

			for (let index = 1 + indexOffset; index < indexCondition; index++) {
				const buttonCloneEl = buttonTemplateEl.cloneNode(true) as HTMLElement;
				buttonCloneEl.classList.add('numbered-control');
				if (selectedPage === index) {
					const activeButtonEl = expressQuerySelector(buttonCloneEl, ".a-button");
					if (activeButtonEl) activeButtonEl.classList.add("a-button--active");
				} else {
					buttonCloneEl.addEventListener("click", onNumberedButtonClicked);
				}
				expressQuerySelector(buttonCloneEl, '.a-button--review', true)
					.insertAdjacentText('beforeend', index.toString());
				const pageButton = buttonCloneEl.querySelector("button");
				if (pageButton) pageButton.title = "page " + index.toString();
				numberedButtonEls.push(buttonCloneEl);
			}

			const docFrag = document.createDocumentFragment();
			docFrag.append(...numberedButtonEls);
			rightControlEL.parentNode!.insertBefore(
				docFrag,
				rightControlEL
			);

			toggleArrowControls();
		};

		const toggleArrowControls = () => {

			showArrowControl(
				(amountOfPagesToShow + indexOffset) < numberOfPages,
				rightControlEL
			);

			showArrowControl(
				(indexOffset - amountOfPagesToShow) >= 0,
				leftControlEL
			);
		};

		const onClickArrowControl = (e: Event) => {

			const controlEl = e.currentTarget as HTMLElement;
			const isLeft = controlEl.querySelector('.icon-arrow-left');

			if (isLeft) indexOffset -= amountOfPagesToShow;
			else indexOffset += amountOfPagesToShow;

			updatePaginations();
		};

		// init pagination controls
		updatePaginations(numberOfPages, 1);

		return {
			updatePaginations,
			dispose: () => {
				leftControlEL.removeEventListener("click", onClickArrowControl);
				rightControlEL.removeEventListener("click", onClickArrowControl);
				numberedButtonEls.forEach(e => e.removeEventListener("click", onNumberedButtonClicked));
			}
		};
	}
